import { Modal } from '@beef/ui-kit';
import React from 'react';
import { ModalActionBar } from "./components/ModalActionBar";
var RequestStatusWrap = function RequestStatusWrap(_ref) {
  var children = _ref.children,
    button = _ref.button,
    buttonReject = _ref.buttonReject,
    onConfirm = _ref.onConfirm,
    onReject = _ref.onReject,
    onClose = _ref.onClose,
    withModal = _ref.withModal;
  if (withModal && onClose) {
    return /*#__PURE__*/React.createElement(Modal, {
      actionBar: button !== null && button !== void 0 && button.text ? /*#__PURE__*/React.createElement(ModalActionBar, {
        button: button,
        buttonReject: buttonReject,
        onConfirm: onConfirm,
        onReject: onReject
      }) : undefined,
      isOpen: true,
      onClose: onClose,
      size: "s",
      "data-t-id": "components-RequestStatus"
    }, children);
  }
  return /*#__PURE__*/React.createElement("div", null, children);
};
export { RequestStatusWrap };